import { HomePage, ProfilePage } from "./pages";
import { withNavigationWatcher } from "./contexts/navigation";
import CompaniesPage from "./pages/companies/companies";
import ProviderAccountsPage from "./pages/provider-accounts/provider-accounts";

const routes = [
  {
    path: "/companies",
    element: CompaniesPage,
  },
  {
    path: "/provider-accounts",
    element: ProviderAccountsPage,
  },
  {
    path: "/profile",
    element: ProfilePage,
  },
  {
    path: "/home",
    element: HomePage,
  },
];

export default routes.map((route) => {
  return {
    ...route,
    element: withNavigationWatcher(route.element, route.path),
  };
});
